<div class="needs">
  <div class="intro">
    Payments taken in <b>Customer Management → Payments</b> where money moved but Accounting has no receipt yet.
    New payments get a receipt automatically, so this list is usually empty.
  </div>

  @if (!Loading && Loaded && !Rows.length) {
  <div class="all-clear">Nothing waiting — every payment has a receipt.</div>
  }

  @if (Loaded) {
  <div class="table-wrap" [class.busy]="Busy || Loading">
    <rms-table [HeaderButtons]="Buttons"
               [parentContext]="this"
               [data]="Rows"
               [columns]="Columns"
               [pageSize]="100"
               tableId="customer-payments-needs-receipt"
               [customizable]="true">
    </rms-table>
  </div>
  } @else {
  <div class="loading">Loading…</div>
  }
</div>
